function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.99996 0C6.66405 0 4.48941 1.22933 2.90559 2.44191C1.31329 3.66098 0.264601 4.90467 0.172545 5.01529L0.172244 5.01565C-0.0577218 5.29269 -0.0569001 5.69758 0.171622 5.97433L0.172545 5.97544C0.264601 6.08606 1.31329 7.32975 2.90559 8.54883C4.48941 9.76141 6.66405 10.9907 8.99996 10.9907C11.3359 10.9907 13.5105 9.76141 15.0943 8.54883C16.6866 7.32975 17.7353 6.08606 17.8274 5.97544L17.8278 5.97496C18.0393 5.71992 18.0589 5.35033 17.8703 5.0732C17.7878 4.95116 16.914 3.6938 15.3994 2.46235C13.8827 1.22918 11.6956 0 8.99996 0ZM4.3078 7.73151C3.15529 6.92309 2.23579 6.03056 1.7254 5.49512C2.235 4.95958 3.15344 4.0672 4.30542 3.25896C5.676 2.29733 7.33267 1.48641 8.99996 1.48641C10.9748 1.48641 12.6724 2.30363 13.976 3.25123C15.076 4.05085 15.8798 4.93215 16.3116 5.45702C15.8139 5.98286 14.89 6.88832 13.7236 7.71095C12.3475 8.68146 10.6791 9.50435 8.99996 9.50435C7.33526 9.50435 5.67898 8.69334 4.3078 7.73151ZM8.99996 2.19331C7.2086 2.19331 5.75231 3.67398 5.75231 5.49535C5.75231 7.31672 7.2086 8.79739 8.99996 8.79739C10.7913 8.79739 12.2476 7.31672 12.2476 5.49535C12.2476 3.67398 10.7913 2.19331 8.99996 2.19331ZM7.21421 5.49538C7.21421 4.49472 8.01578 3.67972 8.99996 3.67972C9.98415 3.67972 10.7857 4.49472 10.7857 5.49538C10.7857 6.49605 9.98415 7.31105 8.99996 7.31105C8.01578 7.31105 7.21421 6.49605 7.21421 5.49538Z",
  fill: "#7195F2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  opacity: 0.5,
  cx: 9.5,
  cy: 5.5,
  r: 2.5,
  fill: "#7195F2"
});

var SvgViews = function SvgViews(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgViews, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/views.107d159c.svg";
export { ForwardRef as ReactComponent };